let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("a2EUO")), load("9IXKO")]).then(() => parcelRequire('4POhN'));